// Som do chamado de garçom.
//
// O padrão é uma campainha sintetizada em vez de arquivo: fica distinta dos
// sons que já existem (pedido novo e cliente esperando no bot), não pesa no
// build e não depende de asset novo. Quem preferir pode trocar por um dos
// sons do sistema na tela de Preferências.

const ARQUIVOS = {
  notificacao_pedido: "/api/sounds/notificacao-pedido",
  aguardando_aceite: "/api/sounds/aguardando-aceite",
  cliente_esperando: "/api/sounds/cliente-esperando",
};

let contexto = null;

function contextoDeAudio() {
  if (contexto) return contexto;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    contexto = Ctx ? new Ctx() : null;
  } catch {
    contexto = null;
  }
  return contexto;
}

// Dois toques curtos descendo, com decaimento — lê como campainha de balcão.
function tocarSino(volume) {
  const ctx = contextoDeAudio();
  if (!ctx) return false;
  try {
    if (ctx.state === "suspended") ctx.resume();
    const ganhoMax = Math.max(0.02, Math.min(1, volume / 100)) * 0.35;
    [
      { hz: 988, atraso: 0 },
      { hz: 740, atraso: 0.18 },
    ].forEach(({ hz, atraso }) => {
      const inicio = ctx.currentTime + atraso;
      const osc = ctx.createOscillator();
      const ganho = ctx.createGain();
      osc.type = "sine";
      osc.frequency.setValueAtTime(hz, inicio);
      ganho.gain.setValueAtTime(0.0001, inicio);
      ganho.gain.exponentialRampToValueAtTime(ganhoMax, inicio + 0.02);
      ganho.gain.exponentialRampToValueAtTime(0.0001, inicio + 0.9);
      osc.connect(ganho);
      ganho.connect(ctx.destination);
      osc.start(inicio);
      osc.stop(inicio + 1);
    });
    return true;
  } catch {
    return false;
  }
}

function tocarArquivo(nome, volume) {
  const url = ARQUIVOS[nome];
  if (!url) return false;
  try {
    const audio = new Audio(url);
    audio.volume = Math.max(0.05, Math.min(1, volume / 100));
    audio.play().catch(() => {});
    return true;
  } catch {
    return false;
  }
}

export function tocarChamado(som) {
  const nome = som?.nome || "sino";
  const volume = Number(som?.volume ?? 80);
  if (nome === "sino") return tocarSino(volume);
  return tocarArquivo(nome, volume) || tocarSino(volume);
}

export const SONS_DISPONIVEIS = [
  { id: "sino", label: "Campainha (padrão)" },
  { id: "notificacao_pedido", label: "Notificação de pedido" },
  { id: "aguardando_aceite", label: "Alerta insistente" },
  { id: "cliente_esperando", label: "Cliente esperando" },
];
